import React from 'react'

export const StaffIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.17857 5.8H5.82143M9.35714 1L8.57143 2.6H10.9286C11.3453 2.6 11.745 2.76857 12.0397 3.06863C12.3344 3.36869 12.5 3.77565 12.5 4.2V15.4C12.5 15.8243 12.3344 16.2313 12.0397 16.5314C11.745 16.8314 11.3453 17 10.9286 17H3.07143C2.65466 17 2.25496 16.8314 1.96026 16.5314C1.66556 16.2313 1.5 15.8243 1.5 15.4V4.2C1.5 3.77565 1.66556 3.36869 1.96026 3.06863C2.25496 2.76857 2.65466 2.6 3.07143 2.6H5.42857M10.8492 17C10.6685 16.0962 10.1866 15.2838 9.48505 14.7002C8.78351 14.1167 7.90548 13.798 6.99961 13.798C6.09374 13.798 5.2157 14.1167 4.51417 14.7002C3.81263 15.2838 3.33071 16.0962 3.15 17M4.64286 1L7 5.8M9.35714 11.4C9.35714 12.7255 8.30181 13.8 7 13.8C5.69819 13.8 4.64286 12.7255 4.64286 11.4C4.64286 10.0745 5.69819 9 7 9C8.30181 9 9.35714 10.0745 9.35714 11.4Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
